import { useQuery, useMutation, useQueryClient } from "react-query";
import { http } from "src/api/http";
import { toast } from "sonner";

export type TwoFactorStatusResponse = {
  enabled: boolean;
  remainingRecoveryCodes: number;
};

export function useTwoFactorStatus(identityId: string | undefined) {
  return useQuery<TwoFactorStatusResponse>({
    queryKey: ["admin", identityId, "2fa", "status"],
    queryFn: () => http(`/api/admin/${identityId}/2fa/status`),
    enabled: !!identityId
  });
}

export function useResetTwoFactor(identityId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation(() => http(`/api/admin/${identityId}/2fa/reset`, { method: "POST" }),
    {
      onSuccess: () => {
        toast.success("2FA was reset for this user.");
        queryClient.invalidateQueries(["admin", identityId, "2fa", "status"]);
      },
      onError: (error: any) => {
        toast.error(error?.message || "Failed to reset 2FA");
      }
    }
  );
}
